import React, { useEffect, useState } from "react";
import CustomSelection from "../../../Components/SelectionComp/CustomSelection";
import CustomFileInput from "../../../Components/InputCompo/CustomFileInput";
import HeaderCompo from "../../../Components/HeaderComp/HeaderCompo";
import ButtonComp from "../../../Components/ButtonComp/ButtonComp";
import { ParagraphComp } from "../../../Components/ParagraphComp/ParagraphComp";
import CustomInput from "../../../Components/InputCompo/CustomInput";
import { Form, Formik, useFormik } from "formik";
import * as Yup from "yup";
import { m } from "framer-motion";
import { zoomIn } from "../../../Functions/GlobalAnimations";
import { InputCompo } from "../../../Components/InputCompo/InputCompo";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
    discoverPanRegCall,
    discoveryInitialQ,
    editRegistration,
    initialSubRegistration,
} from "../../../Store/auth/register";
import ModalComp from "../../../Components/ModalComp";
import { isEqual } from "lodash";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AddCommentIcon from "@mui/icons-material/AddComment";
import DeleteIcon from "@mui/icons-material/Delete";
import { enqueueSnackbar } from "notistack";
import Loading from "../../../Components/Loader/Loading";
import CloseIcon from "@mui/icons-material/Close";
import MultipleSelect from "../../../Components/SelectionComp/MultipleSelect";

const RegistrationSecond = ({ setSubTabs }) => {
    const application_no = localStorage.getItem('RegKey')
    const gsn_no = localStorage.getItem('gsn_no')
    const [tableValues, setTableValues] = useState()
    const DBName = localStorage.getItem('Db_name')
    const [isCheckedAll, setIsCheckedAll] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)

    const [TableData, setTableData] = useState([])

    const queryClient = useQueryClient()

    const { isLoading: fieldLoading, data: question } = useQuery({
        queryKey: "PanQuestions",
        queryFn: () =>
            discoveryInitialQ(
                application_no && DBName ? DBName : "Pending DB",
                application_no
            ),
        cacheTime: 1000 * 60 * 5,
        staleTime: 0, // Setting staleTime to 0 will make sure data is marked as stale immediately
    });

    if (!application_no) {
        setSubTabs({ "Get Started": true });
    }

    const [modalIsOpen, setModalIsOpen] = useState({
        Index: "",
        condition: false,
    });

    // validation for fields
    const modelSchema = Yup.object().shape({
        ...question?.documents?.reduce((schema, fields) => {
            if (fields.type.toLowerCase() !== "section") {
                // Define validation rules
                let fieldValidation = Yup.string();

                // Apply different validation rules based on the field's validation type
                if (
                    fields.validation.toLowerCase() === "email" &&
                    !fields?.depend_question
                ) {
                    fieldValidation = fieldValidation.matches(
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        "Invalid email address"
                    );
                } else if (fields.validation.toLowerCase() === "pan") {
                    fieldValidation = fieldValidation.matches(
                        /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                        "Invalid PAN Number. It should be in the format: ABCDE1234F."
                    );
                } else if (fields.validation.toLowerCase() === "pincode") {
                    fieldValidation = fieldValidation.matches(
                        /^\d{4}$|^\d{6}$/,
                        "PIN code must be exactly 6 digits"
                    );
                } else if (fields.validation.toLowerCase() === "areacode") {
                    fieldValidation = fieldValidation.matches(
                        /^(123|456|789)$/,
                        "incorrect area code"
                    );
                } else if (fields.type.toLowerCase() === "multiselect dropdown") {
                    fieldValidation = Yup.array();
                } else if (fields.validation.toLowerCase() === "website") {
                    fieldValidation = fieldValidation.url("Please enter a valid URL");
                } else if (fields.validation.toLowerCase() === "mobile") {
                    fieldValidation = fieldValidation.matches(
                        /^(?:[0-9]{10}|[0-9]{7})$/,
                        "Invalid contact number"
                    );
                } else if (fields.type.toLowerCase() === "attach") {
                    fieldValidation = Yup.object();
                } else if (fields.validation.toLowerCase() === "darpan") {
                    fieldValidation = fieldValidation.test(
                        "is-valid-darpan",
                        " Darpan Id should be in the format: XX/1234/1234567",
                        (value) => {
                            if (value?.toUpperCase() === "NA") {
                                return true;
                            }
                            return /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value);
                        }
                    );
                } else if (
                    fields.validation.toLowerCase() === "password" &&
                    !fields?.depend_question
                ) {
                    fieldValidation = fieldValidation.min(
                        8,
                        "Password must be at least 8 characters long"
                    );
                }

                // Apply required validation if the field is mandatory
                if (fields.mandatory === 1) {
                    fieldValidation = fieldValidation.required(
                        `${fields.question} is required`
                    );
                }

                // Assign the validation rule to the field in the schema
                schema[fields?.question_no] = fieldValidation;
            }

            return schema;
        }, {}),
    });


    const editModalSchema = Yup.object().shape({
        [isModalOpen?.data?.question_no]: (() => {
            let validation = Yup.string();

            // Check if isModalOpen?.data is defined
            if (!isModalOpen?.data) return validation;

            const fieldType = isModalOpen.data.type?.toLowerCase();
            const fieldValidation = isModalOpen.data.validation?.toLowerCase();

            // Apply validation based on `validation` property
            if (fieldValidation === "email" && !isModalOpen.data?.depend_question) {
                validation = validation.matches(
                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    "Invalid email address"
                );
            } else if (fieldValidation === "pan") {
                validation = validation.matches(
                    /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                    "Invalid PAN Number. Format: ABCDE1234F."
                );
            } else if (fieldValidation === "pincode") {
                validation = validation.matches(
                    /^\d{4}$|^\d{6}$/,
                    "PIN code must be exactly 4 or 6 digits"
                );
            } else if (fieldValidation === "mobile") {
                validation = validation.matches(
                    /^(?:[0-9]{10}|[0-9]{7})$/,
                    "Invalid contact number"
                );
            } else if (fieldValidation === "website") {
                validation = validation.url("Please enter a valid URL");
            } else if (fieldValidation === "darpan") {
                validation = validation.test(
                    "is-valid-darpan",
                    "Darpan ID should be in the format: XX/1234/1234567",
                    (value) =>
                        value?.toUpperCase() === "NA" ||
                        /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value)
                );
            } else if (
                fieldValidation === "password" &&
                !isModalOpen.data?.depend_question
            ) {
                validation = validation.min(
                    8,
                    "Password must be at least 8 characters long"
                );
            } else if (fieldType === "multiselect dropdown") {
                validation = Yup.array().of(Yup.string());
            } else if (fieldType === "attach") {
                validation = Yup.object();
            }

            // Apply 'required' validation if `mandatory` is 1
            if (isModalOpen.data.mandatory === 1) {
                validation = validation.required(
                    `${isModalOpen.data.question} is required`
                );
            }

            return validation;
        })(),
    });

    const formik = useFormik({
        initialValues: question?.documents?.reduce((values, fields) => {
            // Check if there's an answer for the current question_no

            const answer =
                question?.docs_answers.length > 0
                    ? question?.docs_answers?.find(
                        (ans) => ans.question_no === fields.question_no
                    )
                    : "";

            if (
                (answer?.answer &&
                    fields.type.toLowerCase() !== "section" &&
                    question?.docs_answers.length > 0) ||
                (answer?.upload_document &&
                    question?.docs_answers.length > 0 &&
                    fields.type.toLowerCase() !== "section")
            ) {
                values[fields?.question_no] = answer?.answer || {
                    fileName: answer?.upload_document,
                }; // Initialize with the answer if available
            } else {
                values[fields?.question_no] = ""; // Default to an empty string if no answer exists
            }

            return values;
        }, {}),
        validationSchema: modelSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                const tempData = question?.documents?.map((fields) => {
                    if (
                        fields?.type.toLowerCase() === "attach" &&
                        values?.[fields.question_no]
                    ) {
                        return {
                            question_no: fields?.question_no,
                            attach_file: values?.[fields?.question_no]?.file64,
                            file_name: values?.[fields?.question_no]?.fileName,
                        };
                    } else {
                        return {
                            question_no: fields?.question_no,
                            answer: values[fields?.question_no],
                        };
                    }
                });

                const structuredData = {
                    args: {
                        name: application_no,
                        discover_registration_section_1: tempData,
                    },
                };

                await CheckTableFields(structuredData);
            } catch (error) {
                console.error(error);
            } finally {
                setSubmitting(false);
            }
        },
    });

    // file handling manually

    const fileHandler = (e) => {
        if (!e.target.files || e.target.files.length === 0) {
            formik.setFieldValue(e.target.name, "");
            return; // Prevent further execution if no file is selected
        }
        const file = e?.target?.files[0];
        const name = e?.target?.name;
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(",")[1];
                formik.setFieldValue(name, {
                    file64: base64String,
                    fileName: file.name,
                });
            };
            reader.readAsDataURL(file);
        }
    };

    // error handling mutation

    const handleCreateSuccess = () => {
        setTimeout(() => {
            setSubTabs({ Addresses: true });
        }, 1000);
        enqueueSnackbar("success!", { variant: "success" });
    };

    const handleCreateError = (error) => {
        if (error?.response?.data.status_code >= 500) {
            enqueueSnackbar(error?.response?.data?.status_message, {
                variant: "error",
            });
        } else {
            enqueueSnackbar(error?.response?.data?.message || error?.message, {
                variant: "error",
            });
        }
    };

    const createFarmerMutationOptions = {
        onSuccess: handleCreateSuccess,
        onError: handleCreateError,
    };

    // checking table fields manually

    const CheckTableFields = (data) => {
        const findTable = question?.documents?.find(
            (ele) => ele.type.toLowerCase() === "section"
        );
        if (!findTable || !findTable.sub_questions) {
            enqueueSnackbar("Table or sub-questions not found", { variant: "error" });
            return;
        }

        if (TableData?.length > 0) {
            discoverPanReg(data);
            submitTable();
        } else {
            enqueueSnackbar(`Input Entry data`, { variant: "warning" });
        }
    };

    const { mutate: discoverPanReg, isPending: PendingDiscoverPan } = useMutation(
        {
            mutationFn: discoverPanRegCall,
            ...createFarmerMutationOptions,
        }
    );

    // handle the conditions in backend data

    const evaluateCondition = (value1, condition, value2) => {
        switch (condition) {
            case "==":
                return value1 == value2; // Using loose equality as per original suggestion
            case "===":
                return value1 === value2;
            case "!==":
                if (value1 !== value2) {
                    return false;
                }
            case ">":
                return value1 > value2;
            case "<":
                return value1 < value2;
            case ">=":
                return value1 >= value2;
            case "<=":
                return value1 <= value2;
            default:
                return false;
        }
    };

    // table delete rows

    const DeleteRows = () => {
        let tempValues = [...tableValues];
        let deleteArray = [];
        tableValues.map((ele, index) => {
            if (ele?.check) {
                deleteArray.push(index);
            }
        });

        deleteArray.sort((a, b) => b - a);
        deleteArray.forEach((index) => {
            tempValues.splice(index, 1);
        });
        setTableValues(tempValues);
    };

    // table add rows and check mandatory fields and waring messages

    const CheckAllFields = (e, index) => {
        let tempValues = [...tableValues];

        if (typeof index === "undefined") {
            setIsCheckedAll(!isCheckedAll);
            tempValues = tempValues.map((ele) => ({
                ...ele,
                check: !isCheckedAll,
            }));
        } else {
            tempValues[index] = {
                ...tempValues[index],
                check: !tempValues[index].check,
            };
        }
        const findChecked = tempValues.filter((ele) => ele.check);
        if (findChecked.length === tempValues.length) {
            setIsCheckedAll(true);
        } else {
            setIsCheckedAll(false);
        }
        setTableValues(tempValues);
    };

    // manual submission table

    const submitTable = async () => {
        try {
            const main_question_no = question?.documents?.find(
                (ele) => ele.type.toLowerCase() === "section"
            );
            let passedValues = {
                args: {
                    reg_name: application_no,
                    main_question_no: main_question_no?.question_no,
                    question_answers: [],
                },
            };

            // Using forEach instead of map since we're not using the return value of map
            await TableData.forEach((ele, index) => {
                let tempQuestion_answers = [];
                const keys = Object.keys(ele);
                keys.map((key) => {
                    if (ele[key]?.attach_file) {
                        tempQuestion_answers.push({
                            question_no: key,
                            attach_file: ele[key].attach_file,
                            file_name: ele[key].fileName,
                        });
                    } else {
                        tempQuestion_answers.push({
                            question_no: key,
                            answer: ele[key],
                        });
                    }
                });

                passedValues.args.question_answers[index] = tempQuestion_answers;
            });

            if (passedValues.args.question_answers.length > 0) {
                submitSubReg(passedValues);
            }
        } catch (error) { }
    };
    const { mutate: submitSubReg, isPending: subLoading } = useMutation({
        mutationFn: initialSubRegistration,
        ...createFarmerMutationOptions,
    });

    // modal manual opening function

    const openModal = (index) => {
        if (index >= 0) {
            setModalIsOpen({ Index: index, condition: true });
        } else {
            setModalIsOpen({ condition: true });
        }
    };
    // modal manual closing function
    const closeModal = () => {
        setModalIsOpen("");
        formikEntry.resetForm();
    };
    // Table row delete
    const deleteRow = (index) => {
        let tempRows = [...TableData];
        if (index >= 0) {
            tempRows.splice(index, 1);
            setTableData(tempRows);
        } else if (modalIsOpen.Index >= 0) {
            closeModal();
            tempRows.splice(modalIsOpen.Index, 1);
            setTableData(tempRows);
        }
    };
    //  modal table validation
    const entrySchema = Yup.object().shape({
        ...question?.documents
            ?.find((ele) => ele.type.toLowerCase() === "section")
            ?.sub_questions?.reduce((schema, fields) => {
                if (fields.mandatory > 0) {
                    if (fields.type.toLowerCase() === "attach") {
                        schema[fields?.question_no] = Yup.object({
                            attach_file: Yup.string().required("File is required"),
                            fileName: Yup.string().required("File name is required"),
                        });
                    } else if (fields.validation.toLowerCase() === "email") {
                        schema[fields?.question_no] = Yup.string()
                            .email("Invalid email address")
                            .required(`${fields.question} is required`);
                    } else {
                        schema[fields?.question_no] = Yup.string().required(
                            `${fields.question} is required`
                        );
                    }
                }
                return schema;
            }, {}),
    });

    // formik for table

    const formikEntry = useFormik({
        initialValues: question?.documents
            ?.find((ele) => ele.type.toLowerCase() === "section")
            ?.sub_questions?.reduce((values, field) => {
                values[field.question_no] = ""; // Initialize with empty strings
                return values;
            }, {}),
        validationSchema: entrySchema,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            try {
                discoverLegalSub(values);
                resetForm();
            } catch (error) {
                console.error(error);
            } finally {
                setSubmitting(false);
            }
        },
    });

    // Submit the table and review the row for any changes made

    const discoverLegalSub = (formData) => {
        if (modalIsOpen.Index >= 0) {
            if (!isEqual(formData, TableData[modalIsOpen.Index])) {
                let tempData = TableData;
                tempData[modalIsOpen?.Index] = formData;
                setTableData(tempData);
                closeModal();
            } else {
                enqueueSnackbar("No changes detected in your submission", {
                    variant: "warning",
                });
                closeModal();
            }
        } else {
            closeModal();
            setTableData([...TableData, formData]);
        }
    };

    useEffect(() => {
        let tempData = [];
        if (question?.docs_answers?.length > 0) {
            question?.documents?.map((Qn) => {
                if (Qn.type.toLowerCase() === "section") {
                    Qn?.sub_questions?.map((sb) => {
                        question.docs_answers.map((ans) => {
                            if (
                                Qn?.question_no === ans?.question_no &&
                                ans?.type.toLowerCase() === "section"
                            ) {
                                if (ans?.answer?.length > 0) {
                                    ans?.answer?.map((subAns, index) => {
                                        subAns?.map((insAns) => {
                                            // Handle date conversion logic
                                            let answerValue = insAns.answer;
                                            if (insAns.type.toLowerCase() === "date" && insAns.answer) {
                                                if (insAns.answer.match(/^\d{2}-\d{2}-\d{4}$/)) {
                                                    const [day, month, year] = insAns.answer.split('-');
                                                    answerValue = `${year}-${month}-${day}`;
                                                }
                                            }
    
                                            tempData[index] = {
                                                ...tempData[index],
                                                [insAns?.question_no]: answerValue,
                                            };
                                        });
                                    });
                                }
                            }
                        });
                    });
                }
            });
        }
        setTableData(tempData);
    }, [question]);

    // Trigger the edit button and set the Formik values for the modal

    const editTableRow = (index) => {
        const findRow = TableData[index];
        formikEntry.setValues(findRow);
        openModal(index);
    };

    // file handling

    const fileHandlerEntry = (e) => {
        const file = e?.target?.files[0];
        const name = e?.target?.name;
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(",")[1];
                formikEntry.setFieldValue(name, {
                    attach_file: base64String,
                    fileName: file.name,
                });
            };
            reader.readAsDataURL(file);
        }
    };
    const attachFile = (e, setFieldValue) => {
        if (!e.target.files || e.target.files.length === 0) {
            setFieldValue(e.target.name, "");
            return; // Prevent further execution if no file is selected
        }
        const file = e.target.files[0];
        const name = e.target.name;
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(",")[1];
                setFieldValue(name, {
                    attach_file: base64String,
                    file_name: file.name,
                });
            };
            reader.readAsDataURL(file);
        }
    };

    // waiting for fields

    const commonEditOpenModal = (name, data, values, type, template, sub_question_num, subQuestion) => {
        setIsModalOpen({ [name]: true, data, values, index: modalIsOpen?.Index, type: type, template: template, sub_question_num: sub_question_num, subQuestion })
    }

    const commonEditCloseModal = () => {
        if (!editLoading) {
            setIsModalOpen("");
        }
    };

    console.log(
        "docs>>>",
        question?.documents?.find((doc) => doc?.type?.toLowerCase() === "section")
            ?.template
    );

    const hasAnswerForQuestion = (Fields, subQ) => {
        const doc = question?.docs_answers?.length > 0 &&
            question?.docs_answers?.find(doc => doc?.template === Fields);

        // Check if there's at least one non-empty answer
        const isAnyAnswerFilled = doc?.answer?.some(ele =>
            ele.some(dt => dt?.answer) // Checks if any dt.answer is filled
        );

        return isAnyAnswerFilled;
    };

    const updateValues = async (values) => {
        try {
            console.log("isModalOpen>>>>", isModalOpen);
            const currentDate = await new Date();
            let structuredData = "";
            if (isModalOpen?.type?.toLowerCase() === "section") {
                const PreviosData = question?.docs_answers
                    ?.find((doc) => doc?.template === isModalOpen?.template)
                    ?.answer?.[isModalOpen?.index].find(
                        (ans) => ans.question_no === isModalOpen?.data.question_no
                    );
                structuredData = await {
                    args: {
                        gsn_number: gsn_no,
                        date_and_time: formatDateTime(currentDate),
                        gsi_id: application_no,
                        question_id: isModalOpen?.sub_question_num,
                        subquestion_id: isModalOpen?.data?.question_no,
                        subquestion_previous_answer: PreviosData?.answer,
                        subquestion_edited_answer: values?.[isModalOpen?.data?.question_no],
                        subquestion_text: isModalOpen?.data?.question,
                        question_text: isModalOpen?.subQuestion,
                        section_name: 'Discover Registration Details'
                    },
                };
            } else {
                structuredData = await {
                    args: {
                        gsn_number: gsn_no,
                        date_and_time: formatDateTime(currentDate),
                        gsi_id: application_no,
                        question_id: isModalOpen?.data?.question_no,
                        question_text: isModalOpen?.data?.question,
                        previous_answer:
                            isModalOpen?.type?.toLowerCase() === "section"
                                ? values?.[isModalOpen?.template][isModalOpen?.index]?.[
                                isModalOpen?.data?.question_no
                                ] ||
                                (question?.docs_answers?.length > 0 &&
                                    question?.docs_answers
                                        ?.find((doc) => doc?.template === isModalOpen?.template)
                                        ?.answer?.find(
                                            (ele) =>
                                                ele.question_no === isModalOpen?.data.question_no
                                        )) ||
                                ""
                                : values?.normalFields?.[isModalOpen?.data?.question_no] ||
                                (question?.docs_answers?.length > 0 &&
                                    question?.docs_answers?.find(
                                        (doc) =>
                                            doc?.question_no === isModalOpen?.data?.question_no
                                    )?.answer) ||
                                "",
                        edited_answer: values?.[isModalOpen?.data?.question_no],
                        section_name: 'Discover Registration Details'
                    },
                };
            }
            console.log("structuredData>>>>", structuredData);

            await editData(structuredData);
        } catch (error) { }
    };
    const formatDateTime = (isoString) => {
        const date = new Date(isoString);

        // Extract YYYY-MM-DD
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
        const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits

        // Extract HH:MM:SS in 24-hour format
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
    const { mutate: editData, isPending: editLoading } = useMutation({
        mutationFn: editRegistration,
        ...createFarmerMutationOptions,
        onMutate: async () => {
            // Cancel the current query before mutating
            // await queryClient.cancelQueries(['Questions', application_no]);
        },
        onSuccess: () => {
            // Invalidate the query to refetch the latest data
            // queryClient.invalidateQueries(['Questions', application_no]);
        },
    });
    const modalMultiSelectedValues = (values, setModalFieldValue) => {
        const fieldPath = `normalFields.${isModalOpen?.data?.question_no}`;
        setModalFieldValue(fieldPath, values?.[isModalOpen?.data?.question_no]);
        commonEditCloseModal();
    };

    useEffect(() => {
        if (!editLoading) {
            setIsModalOpen('')
        }
    }, [editLoading])

    console.log("modalIsOpen>>>>", modalIsOpen)

    if (PendingDiscoverPan || subLoading || fieldLoading) return <Loading />;

    return (
        <>

            <form className='flex flex-col gap-[30px]' onSubmit={formik.handleSubmit} action="">
                <div className='flex flex-wrap gap-[30px] justify-between w-[100%]'>
                    {question?.documents.map(Fields =>
                        <>
                            {
                                Fields.type.toLowerCase() === 'text' || Fields.type.toLowerCase() === 'number' || Fields.type.toLowerCase() === 'date' || Fields.type.toLowerCase() === 'password' ?
                                    <div className={`${Fields.condition ? !evaluateCondition(formik?.values?.[Fields?.depend_question], Fields.condition, Fields.value) && Fields?.depend_question && 'hidden' : ''} ${Fields?.question.toLowerCase() === 'comment box' ? 'w-[100%]' : ' w-[48%]'} flex gap-[10px] `}>
                                        <div className='w-[100%] '>
                                            <CustomInput required={Fields?.mandatory > 0 ? true : false}
                                                disabled={question?.docs_answers?.length > 0 && question?.docs_answers?.some(doc => doc?.answer)}
                                                {...formik.getFieldProps(Fields.question_no)}
                                                type={Fields.type.toLowerCase()}
                                                name={Fields.question_no} label={Fields.question}
                                            />
                                            <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                                            <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />

                                        </div>
                                        {question?.docs_answers?.length > 0 && question?.docs_answers?.some(doc => doc?.answer) &&
                                            <div className="flex gap-[10px] mt-[8px]">
                                                <div onClick={() => commonEditOpenModal('edit', Fields, formik?.values)} className=" cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]">
                                                    <BorderColorIcon className="text-white" />
                                                </div>
                                                <div onClick={() => commonEditOpenModal('comment', Fields, formik?.values)} className="bg-[#004878] h-fit rounded-full p-[8px]">
                                                    <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                </div>
                                            </div>
                                        }
                                    </div >

                                    :
                                    Fields.type.toLowerCase() === 'dropdown'
                                        ?
                                        <div className={`${Fields?.condition ? !evaluateCondition(formik?.values?.[Fields?.depend_question], Fields.condition, Fields.value) && Fields?.depend_question && 'hidden' : ''} w-[48%] flex gap-[10px]`}>

                                            <div className='w-[100%]'>

                                                <>
                                                    <CustomSelection required={Fields?.mandatory > 0 ? true : false}
                                                        disabled={question?.docs_answers?.length > 0 && question?.docs_answers?.some(doc => doc?.answer)}

                                                        options={Fields?.options}
                                                        {...formik.getFieldProps(Fields.question_no)}
                                                        name={Fields.question_no} label={Fields.question}
                                                        noSort={true}
                                                    />
                                                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields?.question_no]} />
                                                    <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />                                        </>
                                            </div>
                                            {question?.docs_answers?.length > 0 && question?.docs_answers?.some(doc => doc?.answer) &&
                                                <div className="flex gap-[10px] mt-[8px]">
                                                    <div onClick={() => commonEditOpenModal('edit', Fields, formik?.values)} className=" cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]">
                                                        <BorderColorIcon className="text-white" />
                                                    </div>
                                                    <div onClick={() => commonEditOpenModal('comment', Fields, formik?.values)} className="bg-[#004878] h-fit rounded-full p-[8px]">
                                                        <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        :
                                        Fields.type.toLowerCase() === 'attach' ?
                                            <div className={`${Fields?.condition ? !evaluateCondition(formik?.values?.[Fields?.depend_question], Fields.condition, Fields.value) && Fields?.depend_question && 'hidden' : ''} w-[48%] flex gap-[10px]`}>
                                                <div className='w-[100%] ' >
                                                    <>
                                                        <CustomFileInput options={Fields?.options}
                                                            required={Fields?.mandatory > 0 ? true : false}
                                                            // onChange={fileHandler}
                                                            onChange={(e) => fileHandler(e)}
                                                            value={formik?.values?.[Fields?.question_no]?.fileName}
                                                            name={Fields.question_no} label={Fields.question}
                                                            disabled={question?.docs_answers?.length > 0 && question?.docs_answers?.some(doc => doc?.answer)}
                                                        />
                                                        <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                                                        <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                                                    </>
                                                </div>
                                                {question?.docs_answers?.length > 0 && question?.docs_answers?.some(doc => doc?.answer) &&
                                                    <div className="flex gap-[10px] mt-[8px]">
                                                        <div onClick={() => commonEditOpenModal('comment', Fields, formik?.values)} className="bg-[#004878] h-fit rounded-full p-[8px]">
                                                            <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            : ''
                            }

                            {Fields.type.toLowerCase() === "section" ? (
                                <>
                                    <div className="p-[20px] bg-[#F2F2F7]">
                                        <ParagraphComp>
                                            <span className="text-[black] w-fit gap-[10px] font-bold">
                                                {" "}
                                                Note :{" "}
                                            </span>
                                            Please fill all details correctly as you cannot make any
                                            corrections. Upload your registration certificate or the
                                            pages of your trust deed containing name clause and
                                            Sub-Registrar's stamp. Documents can be only PDF with file
                                            size less than 1MB. Click the ADD button to enter the
                                            details of each type of your registration, if you have
                                            multiple registrations such as trust and society
                                        </ParagraphComp>
                                    </div>
                                    <div className="w-[100%]">
                                        <HeaderCompo
                                            tagType="h4"
                                            className="text-xl text-black"
                                            text="Legal Registration (Trust/ Society/ Sec 8 Company (formerly Sec 25) registration details)"
                                        />

                                        {TableData.length <= 0 ? (
                                            <div className=" p-[20px] rounded-md bg-[#F2F2F7] items-center flex flex-col gap-[10px]">
                                                {/* <ImageComp className='h-[200px] ' source={'/Images/Add notes-bro.png'} /> */}
                                                <ParagraphComp
                                                    className="text-md font-bold"
                                                    text="Kindly click here to add your registration details. Please note add a separate entry for each registration."
                                                />
                                                <ButtonComp
                                                    onClick={openModal}
                                                    className="px-[20px] py-[10px] h-[40px] rounded-full bg-[#004878] text-white"
                                                    type="button"
                                                    text="Add Entry"
                                                />
                                            </div>
                                        ) : (
                                            <div className="w-[100%]">
                                                <div className="p-[20px] w-[100%] border-2 rounded-t-xl flex items-center justify-between">
                                                    <HeaderCompo
                                                        className="text-xl text-black mt-0 m-0"
                                                        tagType="h3"
                                                        text="Registration Details"
                                                    />
                                                    {question?.docs_answers.length > 0 ? (
                                                        ""
                                                    ) : (
                                                        <div className="flex gap-[20px]">
                                                            {TableData.find((ele) => ele?.check) && (
                                                                <m.div {...zoomIn}>
                                                                    <ButtonComp
                                                                        type="button"
                                                                        onClick={DeleteRows}
                                                                        text={
                                                                            <i class="fa-regular fa-trash-can text-white"></i>
                                                                        }
                                                                        className="px-[20px] h-[40px] text-white bg-[red] rounded-full py-[5px]"
                                                                    />
                                                                </m.div>
                                                            )}
                                                            <ButtonComp
                                                                onClick={openModal}
                                                                type="button"
                                                                text="Add"
                                                                className="px-[20px] h-[40px] text-white bg-[#004878] rounded-full py-[5px]"
                                                            />
                                                        </div>
                                                    )}
                                                </div>

                                                <table className="border-2 text-[#667085] rounded-t-2xl w-[100%]">
                                                    <tr className="border-b-2 ">
                                                        <th className="p-[10px]">
                                                            {TableData.length > 1 ? (
                                                                <m.div
                                                                    {...zoomIn}
                                                                    className="flex items-center"
                                                                >
                                                                    <InputCompo
                                                                        checked={isCheckedAll}
                                                                        onClick={(e) => {
                                                                            CheckAllFields(e);
                                                                        }}
                                                                        className="w-[25px] h-[25px] rounded-lg mr-auto ml-auto mt-auto mb-auto"
                                                                        type={"checkbox"}
                                                                    />
                                                                </m.div>
                                                            ) : (
                                                                <>
                                                                    <div className="w-[25px]"> </div>
                                                                </>
                                                            )}
                                                        </th>
                                                        <th className="p-[10px] min-w-[100px] text-center">
                                                            No.
                                                        </th>
                                                        {question?.documents
                                                            ?.find(
                                                                (ele) => ele.type.toLowerCase() === "section"
                                                            )
                                                            ?.sub_questions.map((subQ, index) =>
                                                                index <= 3 || index === 6 ? (
                                                                    <>
                                                                        <th className="p-[10px]">
                                                                            {subQ.question}
                                                                        </th>
                                                                    </>
                                                                ) : (
                                                                    ""
                                                                )
                                                            )}
                                                        <th className="p-[10px] min-w-[70px]">Action</th>
                                                    </tr>
                                                    {TableData.map((values, indexRow) => (
                                                        <tr key={indexRow} className="border-b-2">
                                                            <td className="p-[10px] ">
                                                                {TableData?.length > 1 ? (
                                                                    <m.div
                                                                        {...zoomIn}
                                                                        className="flex items-center"
                                                                    >
                                                                        <InputCompo
                                                                            checked={values?.check}
                                                                            onClick={(e) =>
                                                                                CheckAllFields(e, indexRow)
                                                                            }
                                                                            type="checkbox"
                                                                            className="w-[25px] h-[25px] mr-auto ml-auto mt-auto mb-auto"
                                                                        />
                                                                    </m.div>
                                                                ) : (
                                                                    <>
                                                                        <div className="w-[25px]"></div>
                                                                    </>
                                                                )}
                                                            </td>
                                                            <td className="text-center p-[10px] in-w-[70px]">
                                                                {indexRow + 1}
                                                            </td>
                                                            {question?.documents
                                                                ?.find((ele) => ele.type.toLowerCase() === "section")
                                                                ?.sub_questions.map((subQ, indTd) => {
                                                                    if (indTd <= 3 || indTd === 5) {
                                                                        let displayValue = values?.[subQ?.question_no] || values?.[subQ?.question_no]?.fileName;
                                                                        
                                                                        // Convert YYYY-MM-DD to DD-MM-YYYY for display if this is a date field
                                                                        if (subQ.type.toLowerCase() === "date" && displayValue) {
                                                                            if (displayValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
                                                                                const [year, month, day] = displayValue.split('-');
                                                                                displayValue = `${day}-${month}-${year}`;
                                                                            }
                                                                        }
                                                                        
                                                                        return (
                                                                            <td className="text-start p-[10px]" key={subQ.question_no}>
                                                                                {displayValue}
                                                                            </td>
                                                                        );
                                                                    }
                                                                    return "";
                                                                })
                                                            }
                                                            <td className="p-[10px]">
                                                                <div className="flex gap-[10px]">
                                                                    <div
                                                                        onClick={() => editTableRow(indexRow)}
                                                                        className="p-[6px] bg-[#004878] rounded-full"
                                                                    >
                                                                        <BorderColorIcon className="text-white text-[20px]" />
                                                                    </div>
                                                                    <div
                                                                        onClick={() => deleteRow(indexRow)}
                                                                        className="p-[6px] bg-[red] rounded-full"
                                                                    >
                                                                        <DeleteIcon className="text-white text-[20px]" />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                </>
                            ) : (
                                ""
                            )}
                        </>
                    )}
                    <ModalComp
                        modalIsOpen={modalIsOpen.condition}
                        closeModal={closeModal}
                        width={"80%"}
                        maxHeight={"90vh"}
                    >
                        <form action="" onSubmit={formikEntry.handleSubmit}>
                            <div>
                                <HeaderCompo
                                    tagType="h4"
                                    className="text-xl text-black"
                                    text="Add your registration details"
                                />
                                <div className="w-[100%] flex flex-wrap gap-[24px]">
                                    {question?.documents
                                        ?.find((ele) => ele.type.toLowerCase() === "section")
                                        ?.sub_questions.map((Fields) => {
                                            const shouldDisplayOtherField =
                                                (Fields.question_no === "SQ-00100" &&
                                                    formikEntry?.values?.["SQ-00012"] === "Other") ||
                                                (Fields.question_no === "SQ-00099" &&
                                                    formikEntry?.values?.["SQ-00011"]?.trim() ===
                                                    "Other") ||
                                                (Fields.question_no === "SQ-00098" &&
                                                    formikEntry?.values?.["SQ-00005"] === "Other");

                                            return (
                                                <div className="w-[31%] " key={Fields.question_no}>
                                                    {/* Dropdown */}
                                                    {Fields.type.toLowerCase() === "dropdown" && (
                                                        <div className='flex w-[100%] gap-[10px]'>

                                                            <div className='w-[100%]'>
                                                                <CustomSelection
                                                                    disabled={hasAnswerForQuestion(question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.template)}
                                                                    required={Fields.mandatory > 0}
                                                                    options={
                                                                        Fields.question_no === "SQ-00012" ?
                                                                          Fields.options.filter(
                                                                            (ele) => formikEntry.values?.["SQ-00005"] === ele.value
                                                                          ) :
                                                                          Fields.options
                                                                      }
                                                                    {...formikEntry.getFieldProps(Fields.question_no)}
                                                                    name={Fields.question_no}
                                                                    label={Fields.question}
                                                                    noSort={true}
                                                                />
                                                                <ParagraphComp
                                                                    className="text-[red] text-[10px] px-[8px] mt-1"
                                                                    text={formikEntry.errors?.[Fields.question_no]}
                                                                />
                                                            </div>
                                                            {hasAnswerForQuestion(question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.template) &&
                                                                <div className="flex gap-[10px] mt-[8px]">
                                                                    <div
                                                                        onClick={() => commonEditOpenModal('edit', Fields, formikEntry?.values, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.type, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.template, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.question_no, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.question)}
                                                                        className="cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                                                    >
                                                                        <BorderColorIcon className="text-white" />
                                                                    </div>
                                                                    <div
                                                                        onClick={() => commonEditOpenModal('comment', Fields, formikEntry?.values, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.type, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.template, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.question_no, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.question)}
                                                                        className="bg-[#004878] h-fit rounded-full p-[8px]"
                                                                    >
                                                                        <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    )}

                                                    {/* Conditional Text Field */}
                                                    {Fields.type.toLowerCase() === "text" && shouldDisplayOtherField && (
                                                        <div className='flex w-[100%] gap-[10px]'>
                                                            <div className='w-[100%]'>
                                                                <CustomInput
                                                                    disabled={hasAnswerForQuestion(question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.template)}
                                                                    required={Fields.mandatory > 0}
                                                                    {...formikEntry.getFieldProps(Fields.question_no)}
                                                                    name={Fields.question_no}
                                                                    label={Fields.question}
                                                                    type="text"
                                                                />
                                                                <ParagraphComp
                                                                    className="text-[red] text-[10px] px-[8px] mt-1"
                                                                    text={formikEntry.errors?.[Fields.question_no]}
                                                                />
                                                            </div>
                                                            {hasAnswerForQuestion(question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.template) &&
                                                                <div className="flex gap-[10px] mt-[8px]">
                                                                    <div
                                                                        onClick={() => commonEditOpenModal('edit', Fields, formikEntry?.values, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.type, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.template, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.question_no, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.question)}
                                                                        className="cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                                                    >
                                                                        <BorderColorIcon className="text-white" />
                                                                    </div>
                                                                    <div
                                                                        onClick={() => commonEditOpenModal('comment', Fields, formikEntry?.values, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.type, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.template, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.question_no, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.question)}
                                                                        className="bg-[#004878] h-fit rounded-full p-[8px]"
                                                                    >
                                                                        <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    )}

                                                    {/* Regular Text Field */}
                                                    {Fields.type.toLowerCase() === "text" && Fields.question_no === "SQ-00008" && (
                                                        <div className='w-[100%] flex gap-[10px]'>
                                                            <div className='w-[100%]'>
                                                                <CustomInput
                                                                    disabled={hasAnswerForQuestion(question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.template)}
                                                                    required={Fields.mandatory > 0}
                                                                    {...formikEntry.getFieldProps(Fields.question_no)}
                                                                    name={Fields.question_no}
                                                                    label={Fields.question}
                                                                    type="text"
                                                                />
                                                                <ParagraphComp
                                                                    className="text-[red] text-[10px] px-[8px] mt-1"
                                                                    text={formikEntry.errors?.[Fields.question_no]}
                                                                />
                                                            </div>
                                                            {hasAnswerForQuestion(question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.template) &&
                                                                <div className="flex gap-[10px] mt-[8px]">
                                                                    <div
                                                                        onClick={() => commonEditOpenModal('edit', Fields, formikEntry?.values, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.type, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.template, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.question_no, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.question)}
                                                                        className="cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                                                    >
                                                                        <BorderColorIcon className="text-white" />
                                                                    </div>
                                                                    <div
                                                                        onClick={() => commonEditOpenModal('comment', Fields, formikEntry?.values, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.type, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.template, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.question_no, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.question)}
                                                                        className="bg-[#004878] h-fit rounded-full p-[8px]"
                                                                    >
                                                                        <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    )}

                                                    {/* Date Field */}
                                                    {Fields.type.toLowerCase() === "date" && (
                                                        <div className='flex gap-[10px]'>
                                                            <div className='w-[100%]'>
                                                                <CustomInput

                                                                    disabled={hasAnswerForQuestion(question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.template)}
                                                                    required={Fields.mandatory > 0}
                                                                    {...formikEntry.getFieldProps(Fields.question_no)}
                                                                    name={Fields.question_no}
                                                                    label={Fields.question}
                                                                    type="date"
                                                                    allowFutureDates={Fields.question_no === 'SQ-00010' ? true : false}
                                                                />
                                                            </div>
                                                            {hasAnswerForQuestion(question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.template) &&
                                                                <div className="flex gap-[10px] mt-[8px]">
                                                                    <div
                                                                        onClick={() => commonEditOpenModal('edit', Fields, formikEntry?.values, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.type, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.template, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.question_no, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.question)}
                                                                        className="cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                                                    >
                                                                        <BorderColorIcon className="text-white" />
                                                                    </div>
                                                                    <div
                                                                        onClick={() => commonEditOpenModal('comment', Fields, formikEntry?.values, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.type, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.template, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.question_no, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.question)}
                                                                        className="bg-[#004878] h-fit rounded-full p-[8px]"
                                                                    >
                                                                        <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>

                                                    )}

                                                    {/* File Input */}
                                                    {Fields.type.toLowerCase() === "attach" && (
                                                        <div className="flex gap-[10px]">
                                                            <div className="w-[100%]">
                                                                <CustomFileInput
                                                                    disabled={question?.docs_answers?.length > 0}
                                                                    required={Fields?.mandatory > 0}
                                                                    onChange={fileHandlerEntry}
                                                                    value={
                                                                        formikEntry?.values?.[Fields?.question_no]
                                                                            ?.fileName
                                                                    }
                                                                    name={Fields?.question_no}
                                                                    label={Fields?.question}
                                                                />
                                                                <ParagraphComp
                                                                    className="text-[red] text-[10px] px-[8px] mt-1"
                                                                    text={formik.errors?.[Fields.question_no]} // Directly show the error, not the value
                                                                />
                                                            </div>
                                                            {hasAnswerForQuestion(question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.template) &&
                                                                <div className="flex gap-[10px] mt-[8px]">
                                                                    <div
                                                                        onClick={() => commonEditOpenModal('comment', Fields, formikEntry?.values, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.type, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.template, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.question_no, question?.documents?.find(doc => doc?.type?.toLowerCase() === 'section')?.question)}
                                                                        className="bg-[#004878] h-fit rounded-full p-[8px]"
                                                                    >
                                                                        <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                </div>

                                <div className={`w-[100%] ${modalIsOpen.Index >= 0 ? "justify-between" : "justify-end"} flex mt-4`}>
                                    {question?.docs_answers.length > 0 ? null : modalIsOpen.Index >= 0 && (
                                        <div>
                                            <ButtonComp
                                                onClick={deleteRow}
                                                type="button"
                                                className="border-none bg-none px-[20px] py-[6px] bg-[red] rounded-full text-white"
                                                text="Delete"
                                            />
                                        </div>
                                    )}
                                    <div className="flex gap-4">
                                        <ButtonComp
                                            type="button"
                                            onClick={closeModal}
                                            className="border-none bg-none px-[20px] py-[6px] rounded-full text-black"
                                            text="Cancel"
                                        />
                                        {question?.docs_answers.length > 0 ? null : (
                                            <ButtonComp
                                                type="submit"
                                                className="border-none bg-none bg-[#004878] px-[20px] py-[6px] rounded-full text-[white]"
                                                text="Submit"
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </ModalComp>
                </div >
                {
                    question?.docs_answers.length > 0 ? ''
                        :
                        <div className='flex justify-end'>
                            <ButtonComp type={'submit'} className='px-[20px] py-[6px] h-[40px] text-white bg-[#004878] rounded-full' text='Save & Next' />
                        </div>
                }

            </form >


            <ModalComp width={'35%'} modalIsOpen={isModalOpen?.['comment']} closeModal={commonEditCloseModal} >
                <HeaderCompo className='text-2xl mb-[10px] font-bold text-black mt-[10px] text-center' tagType={'h3'} text='Comment' />
                <ParagraphComp className='text-lg text-black text-center' >
                    {isModalOpen?.type?.toLowerCase() === 'section' ?
                        ((question?.docs_answers?.length > 0 &&
                            Array.isArray(question?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer)) &&
                            question?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.[isModalOpen?.index]?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.comments_for_npo) || 'No comment was added by the administrator' :
                        (question?.docs_answers?.length > 0 &&
                            question?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.comments_for_npo) || 'No comment was added by the administrator.'}
                </ParagraphComp>
                <div className="flex justify-end">
                    <ButtonComp onClick={commonEditCloseModal} type='button' className=' mt-[10px] py-[5px] px-[10px] rounded-[20px] border-2 border-[#004878] text-[#004878]'>
                        Close
                    </ButtonComp>
                </div>

            </ModalComp>
            <ModalComp width={'35%'} modalIsOpen={isModalOpen?.['edit']} closeModal={commonEditCloseModal} >
                {console.log("isModalOpen>>>>>", isModalOpen)}
                <Formik
                    enableReinitialize
                    initialValues={{
                        [isModalOpen?.data?.question_no || 'default_question_no']: '',
                    }}
                    validationSchema={editModalSchema}
                    onSubmit={(values) => {
                        updateValues(values, formikEntry?.setFieldValue);
                    }}
                >


                    {({ values: modalValues, errors: modalErrors, handleChange, setFieldValue: setModalFieldValue }) => (

                        <Form action="">
                            {console.log("values>>>>>", modalValues)}

                            <div className='h-auto'>
                                <div className='flex justify-end'>
                                    <div className='cursor-pointer' onClick={commonEditCloseModal}>
                                        <CloseIcon />
                                    </div>
                                </div>
                                <HeaderCompo className='text-2xl mb-[10px] font-bold text-black mt-[10px] text-center' tagType={'h3'} text='Edit' />
                                <ParagraphComp className='text-lg text-black text-start' text='Question' />
                                <ParagraphComp className='text-md mt-[10px] text-[#3f3f3f] text-start' text={isModalOpen?.data?.question} />
                                {(isModalOpen?.data?.type === 'Attach' && question?.docs_answers?.length > 0
                                    ? { file_name: question?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.upload_document || '' }
                                    : isModalOpen?.type?.toLowerCase() === 'section'
                                        ? formikEntry?.values?.[isModalOpen?.data?.question_no] ||
                                        (question?.docs_answers?.length > 0 &&
                                            question?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)
                                                ?.answer?.find(ele => ele.question_no === isModalOpen?.data.question_no)) || ''
                                        : formikEntry?.values?.[isModalOpen?.data?.question_no] ||
                                        (question?.docs_answers?.length > 0 &&
                                            question?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer))
                                    ?
                                    <ParagraphComp className='text-lg mt-[10px] text-black text-start' text='Current Answer' />
                                    : ''
                                }
                                <ParagraphComp className='text-md mt-[10px] text-[#3f3f3f] text-start'>
                                    {(() => {
                                        let value = '';
                                        
                                        // Get the appropriate value based on modal type
                                        if (isModalOpen?.data?.type === 'Attach' && question?.docs_answers?.length > 0) {
                                        value = { file_name: question?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.upload_document || '' };
                                        } 
                                        else if (isModalOpen?.type?.toLowerCase() === 'section') {
                                        value = formikEntry?.values?.[isModalOpen?.data?.question_no] ||
                                                (question?.docs_answers?.length > 0 && Array.isArray(question?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer) &&
                                                question?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)
                                                    ?.answer?.find(ele => ele.question_no === isModalOpen?.data.question_no)) || '';
                                        } 
                                        else {
                                        value = formikEntry?.values?.[isModalOpen?.data?.question_no] ||
                                                (question?.docs_answers?.length > 0 &&
                                                    question?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer) || '';
                                        }

                                        // Convert date format if needed
                                        if (isModalOpen?.data?.type?.toLowerCase() === 'date' && value) {
                                        if (value.match(/^\d{4}-\d{2}-\d{2}$/)) {
                                            const [year, month, day] = value.split('-');
                                            value = `${day}-${month}-${year}`;
                                        }
                                        }

                                        return value;
                                    })()}
                                </ParagraphComp>
                                {['text', 'number', 'date', 'password'].includes(isModalOpen?.data?.type.toLowerCase()) ?
                                    <div className="mt-[20px]">
                                        <CustomInput
                                            required
                                            type={isModalOpen?.data?.type?.toLowerCase()}
                                            name={isModalOpen?.data?.question_no}
                                            value={modalValues?.[isModalOpen?.data?.question_no]}
                                            onChange={handleChange}
                                            label="New Answer"
                                        />
                                        <ParagraphComp className="text-[red] text-[10px] px-[8px] mt-1" text={modalErrors?.[isModalOpen?.data?.question_no]} />
                                    </div>
                                    :
                                    isModalOpen?.data?.type.toLowerCase() === 'dropdown' ?
                                        < div className='mt-[20px]'>
                                            <CustomSelection
                                                imgKey='flag'
                                                exDataKey={isModalOpen?.data?.question === 'Country Code' ? 'label' : undefined}
                                                mappingKey={isModalOpen?.data?.question === 'Country Code' ? 'phone' : undefined}
                                                options={isModalOpen?.data?.options}
                                                required={true}
                                                value={modalValues?.[isModalOpen?.data.question_no]}
                                                onChange={handleChange}
                                                name={isModalOpen?.data.question_no}
                                                label='New Answer'
                                            />
                                            <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                                        </div>
                                        : isModalOpen?.data?.type.toLowerCase() === 'multiselect dropdown' ?
                                            < div className='mt-[20px]'>
                                                <MultipleSelect
                                                    required={true}
                                                    options={isModalOpen?.data?.options
                                                    }
                                                    maxSelect={isModalOpen?.data.validation === 'Select Upto 3' && 3}
                                                    mappingKey={isModalOpen?.data?.question_no !== "DRQ-00077" ? "option" : 'option'} // Pass mapping key if needed
                                                    onValueChange={(values) => modalMultiSelectedValues(formikEntry?.values, setModalFieldValue)}
                                                    selectedValues={formikEntry?.values?.[isModalOpen?.data?.question_no] || []}
                                                    name={isModalOpen?.data?.question_no}
                                                    label='New Answer'
                                                />
                                                <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />

                                            </div>
                                            :
                                            isModalOpen?.data?.type.toLowerCase() === 'attach' ?
                                                <div className='mt-[20px]'>
                                                    <CustomFileInput
                                                        required={true}
                                                        onChange={(e) => attachFile(e, setModalFieldValue)}
                                                        value={modalValues?.[isModalOpen?.data?.question_no].file_name}
                                                        name={isModalOpen?.data?.question_no}
                                                        label="New Answer"
                                                    />
                                                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                                                </div>
                                                : ''

                                }

                                <div className="flex justify-center mt-[15px]">
                                    <ButtonComp
                                        disabled={editLoading ? true : false}
                                        className="w-[150px] rounded-full bg-[#004878] p-[6px] text-white border-none"
                                        type="Submit"
                                        text={editLoading ? "Saving..." : "Save"}
                                    />
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </ModalComp>
        </>
    );
};

export default RegistrationSecond;
